// Utils
import { propIn } from '../../../common/utils/immutableHelper';

export const electronNativeThemeSelector = propIn(['app', 'electronTheme', 'nativeTheme']);
